import * as types from './index';


export const documentListAction = (data) => {
    return {
    type: types.DOCUMENT_LIST,
    data
    }
};

export const skillDocumentListAction = (data) => {
    return {
    type: types.DOCUMENT_SKILL_LIST,
    data
    }
};

export const documentAddAction = (data) => {
    return {
    type: types.DOCUMENT_ADD,
    data
    }
};

export const documentEditAction = (data) => {
    return {
    type: types.DOCUMENT_EDIT,
    data
    }
};

export const documentUpdateAction = (data) => {
    return {
    type: types.DOCUMENT_UPDATE,
    data
    }
};

export const documentDeleteAction = (data) => {
    return {
    type: types.DOCUMENT_DELETE,
    data
    }
};

export const documentFileSaveAction = (data) => {
    return {
    type: types.DOCUMENT_FILE_SAVE,
    data
    }
};

export const documentFileDeleteAction = (data) => {
    return {
    type: types.DOCUMENT_FILE_DELETE,
    data
    }
};

export const documentStatusUpdateAction = (data) => {
    return {
    type: types.DOCUMENT_STATUS_UPDATE,
    data
    }
};

export const passportFileSaveAction = (data) => {
    return {
    type: types.PASSPORT_FILE_SAVE,
    data
    }
};


export const visaFileSaveAction = (data) => {
    return {
    type: types.VISA_FILE_SAVE,
    data
    }
};